
<div *ngIf="dropdownList">
  <ng-multiselect-dropdown [placeholder]="placeholder"
                           [settings]="dropdownSettings"
                           [data]="dropdownList"
                           [(ngModel)]="selectedItems"
                           (onSelect)="onItemSelect($event)"
                           (onDeSelect)="onItemSelect($event)"
                           (onSelectAll)="onSelectAll($event)">
  </ng-multiselect-dropdown>
</div>
